import _ from 'lodash';

const checkEmailForDigitalorEPOI = (jobVM, emailAddress1Value) => {
    const isDigitalEnrolled =
        _.get(jobVM, 'baseData.edeliveryEnrolled_WMIC.value') ||
        _.get(jobVM, 'lobData.personalAuto.epoiEnrolled_WMIC.value');

    return !isDigitalEnrolled || !_.isEmpty(emailAddress1Value);
};

export default {
    checkEmailForDigitalorEPOI,
};
